module.exports = __webpack_public_path__ + "res/img/casting.de92abf2.png";